<template>
    <div>
        <div class="row border-bottom">
            <div class="col-12">
                <div class="mb-2 float-right">
                    <div class="row">
                        <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                            <div class="btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button id="refresh" class="btn btn-primary" data-original-title="Refresh" @click="getClaimPaymentsForClaim(claimId)"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button id="new" class="btn btn-primary" data-original-title="NEw"><i class="fas fas fa-plus" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <table v-else class="table">
            <thead>
                <tr>
                    <th scope="col">Gadget</th>
                    <th scope="col">Payment Type</th>
                    <th scope="col">Payee Type</th>
                    <th scope="col">Provider</th>
                    <th scope="col">Transaction Type</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Net</th>
                    <th scope="col">Tax</th>
                    <th scope="col">Gross</th>
                    <th scope="col">Date</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <!-- :class="itm.transactionTypeId == 1 ? 'bg-danger' : 'bg-success'" -->
                <tr v-for="(itm, idx) in claimPayments" :key="'claimpaymentlist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.gadgetDisplayLabel}}</td>
                    <td>{{itm.claimPaymentTypeLabel}}</td>
                    <td>{{itm.payeeTypeLabel}}</td>
                    <td>{{itm.settlementOptionProviderLabel}}</td>
                    <td>{{itm.transactionTypeLabel}}</td>
                    <td>{{itm.currencyCode}}</td>
                    <td>{{itm.net}}</td>
                    <td>{{itm.tax}}</td>
                    <td>{{itm.gross}}</td>
                    <td>{{itm.dateCreated}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)" @click="handleEditClick(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Edit
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Delete
                            </b-dropdown-item>
                            <!--<b-dropdown-item href="javascript:void(0)" @click="handleCreateClaimPaymentClick(idx,itm)" :disabled="itm.claimPaymentId > 0">
                            <i v-if="false" :class="iconClass"></i> Create Claim Payment
                        </b-dropdown-item>-->
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-modal :id="'claim-payment-edit-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer>
            <div v-if="selectedItem">
                <div class="row mt-2">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.gadgetDisplayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payment Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.claimPaymentTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payee Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.payeeTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Provider</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.settlementOptionProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Transaction Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.transactionTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.currencyCode}}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Net</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentNet" v-model="editAmountModel.net">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'net').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'net').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Tax</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentTax" v-model="editAmountModel.tax">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'tax').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'tax').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Gross</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="editAmountModel.gross">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'gross').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'gross').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="loading" @click="handleCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!editAmountModelIsValid() || loading" @click="handleOKClick()">OK</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    import { required, numeric, minLen } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'

    export default {
        name: 'ClaimPayments',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean
        },
        mixins: [
            watchAll,
            validator
        ],
        components: {},
        data: () => {
            return {
                baseUrl: API_BASE_URL,
                claimPayments: [],
                selectedRowIndex: null,
                selectedItem: null,

                editAmountModel: {
                    net: 0,
                    tax: 0,
                    gross: 0,
                    validators: [
                        {
                            item: 'net',
                            validators: [
                                numeric
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'tax',
                            validators: [
                                numeric
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'gross',
                            validators: [
                                required,
                                numeric
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, Numeric'
                        }
                    ]
                },
                loading: false
            }
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getClaimPaymentsForClaim(this.claimId)
                }
            }
        },
        computed: {
            
        },
        methods: {
            async getClaimPaymentsForClaim(claimId) {
                //console.log('PING2')
                if (claimId && !isNaN(claimId)) {
                    //console.log('PING3')
                    this.loading = true
                    try {
                        const response = await axios.get('/api/admin/v1/finance/claimpayments/' + claimId)
                        //console.log("-r : ", response)
                        const { data } = response
                        this.claimPayments = data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            handleRowClick(rowIndex, item) {
                this.selectedRowIndex = rowIndex
            },
            handleEditClick(rowIndex, item) {
                this.selectedItem = item
                this.editAmountModel.net = parseInt(item.net)
                this.editAmountModel.tax = parseInt(item.tax)
                this.editAmountModel.gross = parseInt(item.gross)
                this.$bvModal.show('claim-payment-edit-modal-' + this.$vnode.key)
            },
            async handleDeleteClick(rowIndex, item) {
                this.selectedItem = item

                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete this payment?')
                if (confirm != null) {
                    console.log('-c : ', confirm)
                    if (confirm == true) {
                        let { id, rv } = this.selectedItem
                        let payload = {
                            claimPaymentId: id,
                            rv: rv
                        }
                        //console.log('-p : ', payload)

                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/finance/deleteclaimpayment/', payload)
                            //console.log("-r : ", response)
                            const { data } = response
                            if (data) {
                                this.claimPayments = this.claimPayments.filter(i => i.id !== data.id)
                            }

                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            editAmountModelRunValidators() { runValidators(this.editAmountModel) },
            editAmountModelIsValid() { return getValidatorsIsValid(this.editAmountModel) },
            async handleOKClick() {
                let { net, tax, gross } = this.editAmountModel
                let { id, rv } = this.selectedItem
                let payload = {
                    claimPaymentId: id,
                    net: parseInt(net),
                    tax: parseInt(tax),
                    gross: parseInt(gross),
                    rv: rv
                }
                //console.log('-p : ', payload)
                this.loading = true
                try {
                    const response = await axios.post('/api/admin/v1/finance/updateclaimpaymentamounts/', payload)
                    //console.log("-r : ", response)
                    const { data } = response
                    if (data) {
                        this.claimPayments = this.claimPayments.map(i => i.id !== data.id ? i : data)
                        this.$bvModal.hide('claim-payment-edit-modal-' + this.$vnode.key)
                    }

                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            async handleCreateClaimPaymentClick(idx, itm) {
                //let { cardPaymentId } = itm
                //let payload = {
                //    sourceEntityId: cardPaymentId,
                //    sourceEntityType: 3
                //}

                //console.log('-i : ', itm)
                this.loading = true
                try {
                    //const response = await axios.post('/api/admin/v1/finance/createclaimpayment/', payload)
                    //console.log("-r : ", response)
                    //const { data } = response
                    //if (data) {

                    //}

                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            handleCloseClick() {
                this.$bvModal.hide('claim-payment-edit-modal-' + this.$vnode.key)
                this.selectedItem = null
                this.editAmountModel.net = 0
                this.editAmountModel.tax = 0
                this.editAmountModel.gross = 0
            }
        },
        async mounted() {
            //console.log('PING')
            //await this.getClaimPaymentsForClaim(this.claimId)

            this.watchAll(['editAmountModel.net', 'editAmountModel.tax', 'editAmountModel.gross'],
                this.editAmountModelRunValidators.bind(this))

        }
    }
</script>